import { getCapabilities } from './capabilityEnv';

/**
 * Whether the browser will show the `getUserMedia` permission prompt WITHOUT a user gesture.
 * Only iOS and iPadOS need a click first (so the module offers an Allow button there); Chrome,
 * Edge, Firefox and Safari on macOS open the prompt by themselves.
 */
export const canAutoPrompt = !getCapabilities().requiresUserGesture;
